import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { PrivateRoute } from "components";
import { Permission } from "types/permission";
import SubUserList from "./AiccCustomer/SubUser";
import SubUserDetail from "./AiccCustomer/SubUser/SubUserDetail";
import ConversationDetail from "./AiccCustomer/SubUser/ConversationDetail";
import ConversationListRedirect from "./AiccCustomer/SubUser/ConversationListRedirect";
import UserFeedbackList from "./AiccCustomer/UserFeedback";
import SetUsageLimits from "./AiccCustomer/UsageLimits";
import LanguageManagement from "./LanguageManagement";
import TestAccount from "./TestAccount";
import PromptManagement from "./Prompt";
import DefaultScenarioManagement from "./LearningAssets/DefaultScenario";
import ScenarioCategoryManagement from "./LearningAssets/ScenarioCategory";
import LessonInformationManagement from "./LearningAssets/LessonInformation";
import VocabularyManagement from "./LearningAssets/Vocabulary";
import SttSetting from "./LearningAssets/SttSetting";
import TtsSetting from "./LearningAssets/TtsSetting";
import UiElementTranslation from "./LearningAssets/UiElementTranslation";
import LessonReviewScript from "./LearningAssets/LessonReviewScript";
import CanDoStatementManagement from "./LearningAssets/CanDoStatement";

function AiccPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <Redirect to={`${path}/customer/subusers`} />
      </Route>
      <Route exact path={`${path}/customer`}>
        <Redirect to={`${path}/customer/subusers`} />
      </Route>
      <PrivateRoute exact path={`${path}/customer/subusers`} permission={Permission.MANAGE_AICC_SUBUSER}>
        <SubUserList />
      </PrivateRoute>
      <PrivateRoute exact path={`${path}/customer/subusers/:subUserId`} permission={Permission.MANAGE_AICC_SUBUSER}>
        <SubUserDetail />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/customer/subusers/:subUserId/languages/:languageId/conversations`}
        permission={Permission.MANAGE_AICC_SUBUSER}
      >
        <ConversationListRedirect />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/customer/subusers/:subUserId/languages/:languageId/conversations/:conversationId`}
        permission={Permission.MANAGE_AICC_SUBUSER}
      >
        <ConversationDetail />
      </PrivateRoute>
      <PrivateRoute exact path={`${path}/customer/feedback`} permission={Permission.MANAGE_AICC_USER_FEEDBACK}>
        <UserFeedbackList />
      </PrivateRoute>
      <PrivateRoute exact path={`${path}/customer/usage-limits`} permission={Permission.VIEW_AICC_USAGE_LIMIT}>
        <SetUsageLimits />
      </PrivateRoute>
      <PrivateRoute exact path={`${path}/languages`} permission={Permission.VIEW_AICC_LANGUAGE}>
        <LanguageManagement />
      </PrivateRoute>
      <PrivateRoute exact path={`${path}/test-accounts`} permission={Permission.MANAGE_AICC_TEST_ACCOUNT}>
        <TestAccount />
      </PrivateRoute>
      <Route exact path={`${path}/learning-assets`}>
        <Redirect to={`${path}/learning-assets/default-scenarios`} />
      </Route>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/default-scenarios`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <DefaultScenarioManagement />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/scenario-categories`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <ScenarioCategoryManagement />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/lesson-information`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <LessonInformationManagement />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/vocabularies`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <VocabularyManagement />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/stt-settings`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <SttSetting />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/tts-settings`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <TtsSetting />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/ui-element-translations`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <UiElementTranslation />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/lesson-review-scripts`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <LessonReviewScript />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/learning-assets/can-do-statements`}
        permission={Permission.MANAGE_AICC_LEARNING_ASSET}
      >
        <CanDoStatementManagement />
      </PrivateRoute>
      {/* Not exact: prompt management owns a Switch of its own, for its tabs and its detail page. */}
      <PrivateRoute path={`${path}/prompts`} permission={Permission.MANAGE_AICC_PROMPT}>
        <PromptManagement />
      </PrivateRoute>
    </Switch>
  );
}

export default AiccPage;
